import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './dishListsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type DishListsQuery_dishLists_DishListPaginationHandler_records_DishList = {
  __typename: 'DishList',
  id: number,
  categoryName?: string | null,
  description?: string | null,
  friendlySlug: string,
  name: string,
  photoUrl?: string | null,
  popsCount: number,
  slug: string,
  userDisplayName: string
};

export type DishListsQuery_dishLists_DishListPaginationHandler = {
  __typename: 'DishListPaginationHandler',
  records: Array<DishListsQuery_dishLists_DishListPaginationHandler_records_DishList>
};

export type DishListsQuery_Query = {
  __typename?: 'Query',
  dishLists: DishListsQuery_dishLists_DishListPaginationHandler
};


export type DishListsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type DishListsQuery = DishListsQuery_Query;


export const DishListsDocument = /*#__PURE__*/ document as unknown as DocumentNode<DishListsQuery, DishListsQueryVariables>;


/**
 * __useDishListsQuery__
 *
 * To run a query within a React component, call `useDishListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishListsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useDishListsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DishListsQuery, DishListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishListsQuery, DishListsQueryVariables>(DishListsDocument, options);
      }
export function useDishListsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishListsQuery, DishListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishListsQuery, DishListsQueryVariables>(DishListsDocument, options);
        }
export function useDishListsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListsQuery, DishListsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishListsQuery, DishListsQueryVariables>(DishListsDocument, options);
        }
export type DishListsQueryHookResult = ReturnType<typeof useDishListsQuery>;
export type DishListsLazyQueryHookResult = ReturnType<typeof useDishListsLazyQuery>;
export type DishListsSuspenseQueryHookResult = ReturnType<typeof useDishListsSuspenseQuery>;
export type DishListsQueryResult = ApolloReactCommon.QueryResult<DishListsQuery, DishListsQueryVariables>;